<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    title="产品编辑"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="70%"
    top="5%"
    :close-on-click-modal="false"
  >
    <el-row :gutter="20">
      <el-col :span="16">
        <el-form
          :model="item"
          ref="itemform"
          label-width="120px"
          :rules="rules"
        >
          <div class="border-style">基本信息</div>
          <el-form-item label="产品型号名称" prop="IpcProductModelID">
            <select2
              labelName="NameNumber"
              v-model="item.IpcProductModelID"
              url="ipc/model/product/list?order=name"
              :clearable="false"
              placeholder="选择产品型号"
              no-data-text="没有产品型号"
              :urlParams="{
                where: {},
              }"
              q="NameNumber:like"
              :qinwhere="true"
              :queryOne="false"
              style="width: 100%"
              :currentList="currentProductModel"
              :disabled="true"
            ></select2>
          </el-form-item>
          <el-form-item label="产品SN" prop="SN">
            <el-input v-model.trim="item.SN"></el-input>
          </el-form-item>
          <el-form-item label="机器码">
            <el-input v-model.trim="item.MachineCode" disabled></el-input>
          </el-form-item>
          <el-form-item label="入库日期" prop="StockinAt">
            <el-date-picker
              v-model="item.StockinAt"
              style="width: 100%"
              type="date"
              disabled
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="备注" prop="Remark">
            <el-input
              v-model.trim="item.Remark"
              :autosize="{ minRows: 3 }"
              type="textarea"
              placeholder="请输入备注"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="文件上传" prop="file" v-if="item.Status === 1">
            <div align="left" style="float: left">
              <el-button size="mini" type="primary" @click="onCreateClick()"
                >选择文件</el-button
              >
            </div>
            <div align="left">
              <el-upload
                ref="upload"
                action=""
                :headers="uploadHeader"
                :on-remove="handleRemove"
                :on-error="handleError"
                :file-list="fileList"
                :on-preview="handlePreview"
              >
                <!-- <el-button size="mini" type="primary"
                >选择文件</el-button
              > -->
              </el-upload>
            </div>
          </el-form-item>
          <div
            style="
              text-align: left;
              font-size: smaller;
              padding-bottom: 10px;
              padding-left: 110px;
            "
            v-if="item.Status !== 1 && fileList.length > 0"
          >
            <span
              style="padding-left: 10px"
              v-for="attachment in fileList"
              :key="attachment.url"
            >
              <a
                target="_blank"
                :href="attachment.url"
                :download="attachment.name"
                style="color: #409eff"
                >{{ attachment.name }}</a
              >
            </span>
          </div>
        </el-form>

        <div class="border-style">相关配件</div>
        <el-table :data="item.IpcAccessories" v-loading="loading">
          <el-table-column type="index" width="40"></el-table-column>
          <el-table-column prop="IpcAccessoryModel.Name" label="配件名称" />
          <el-table-column
            prop="IpcAccessoryModel.Brand"
            label="品牌"
            width="100"
          />
          <el-table-column
            prop="IpcAccessoryModel.ModelNumber"
            label="型号"
            width="100"
          />
          <el-table-column prop="SN" label="配件SN">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.SN"
                v-bind:ref="'row' + scope.$index"
                @keyup.native="keyup($event, scope.$index, 2)"
                style="color: blue"
              ></el-input>
            </template>
          </el-table-column>
        </el-table>

        <div style="padding-top: 10px; text-align: right">
          <el-button
            type="primary"
            @click="onEdit"
            :disabled="editting"
            size="small"
            v-if="item.Status === 1"
          >
            <i class="far fa-save"></i> 保 存
          </el-button>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="border-style">日志信息</div>
        <div class="dialogDiv">
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(activity, index) in activities"
              :key="index"
              :timestamp="
                $sys.dateFormat(activity.UpdatedAt) + ' ' + activity.Operator
              "
              placement="top"
            >
              <el-card>
                <p style="margin-top: 0px; margin-bottom: 0px">
                  {{ activity.Content }}
                </p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-col>
    </el-row>

    <el-dialog
      title="文件上传"
      :visible="uploadVisabled"
      @close="onFileClose"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-form
        :model="fileItem"
        ref="fileItemForm"
        label-width="85px"
        :rules="fileRules"
      >
        <el-form-item label="文件上传" prop="file">
          <el-upload
            ref="uploadFile"
            action=""
            :http-request="httpFileRequest"
            :headers="uploadHeader"
            :multiple="false"
            :limit="1"
            :auto-upload="false"
            :on-error="handleError"
            :on-change="judgeFileName"
          >
            <el-button size="small" type="primary">选择文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="文件名称" prop="fileName">
          <el-input v-model.trim="fileItem.fileName"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="onFileClose">
          <i class="fas fa-times"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onSubmit" :disabled="submitting">
          <i class="far fa-save"></i> 确 定
        </el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      loading: false,
      rules: {
        IpcProductModelID: [
          { required: true, message: "产品型号名称不能为空", trigger: "blur" },
        ],
        SN: [{ required: true, message: "产品SN不能为空", trigger: "blur" }],
        Remark: [{ max: 64000, message: "内容过多", trigger: "blur" }],
      },
      pager: {
        total: 0,
        page: 1,
        size: -1,
      },
      editting: false,
      activities: [], //日志
      fileList: [],
      removeList: [],
      index: 0,
      currentProductModel: [],
      uploadHeader: {
        Authorization: `Bearer ${window.localStorage.getItem("jwtToken")}`,
        Accept: "application/json",
      },
      fileItem: {
        fileName: "",
      },
      fileRules: {
        fileName: [
          { required: true, message: "文件名称不能为空", trigger: "blur" },
        ],
      },
      submitting: false,
      uploadVisabled: false,
    };
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);
      this.$axios
        .get(`ipc/product/${this.value.ID}`)
        .then((response) => {
          this.item = response.data;

          if (this.item.Attachments && this.item.Attachments.length > 0) {
            this.item.Attachments.forEach((att) => {
              this.index += 1;
              this.fileList.push({
                uid: this.index,
                name: att.Name,
                url: att.Url,
              });
            });
          }

          if (this.item.IpcProductModel != null) {
            this.currentProductModel = [
              {
                ID: this.item.IpcProductModelID,
                NameNumber: this.item.IpcProductModel.NameNumber,
              },
            ];
          }
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });

      this.getLog();
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();

      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
      this.fileList = [];
      this.removeList = [];
    },
    getLog() {
      this.$axios
        .get(`ipc/product/${this.value.ID}/record`, {
          params: {
            ...this.pager,
            order: ["-updated_at", "-id"],
          },
        })
        .then((response) => {
          this.activities = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    //修改信息
    onEdit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.editting = true;
        //排除删除的附件
        if (this.removeList.length !== 0) {
          this.removeList.forEach((url) => {
            this.item.Attachments.splice(
              this.item.Attachments.findIndex((item) => item.Url === url),
              1
            );
          });
          this.$axios.delete("ipc/attachmentDelete", {
            data: { urls: this.removeList },
          });
        }

        this.$emit("input", this.item);
        const itemData = { ...this.item };
        // 保存的操作
        this.$axios
          .request({
            url: `/ipc/product/stock-in-edit/${this.item.ID}`,
            method: "put",
            data: itemData,
          })
          .then(() => {
            this.$message.success("修改成功");
            this.editting = false;

            if (this.fileList.length > 0) {
              this.$refs.upload.clearFiles();
            }
            this.fileList = [];
            this.removeList = [];
            this.$emit("form:created", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.editting = false;
            this.$emit("form:created", false);
            this.$emit("form:saved", false);
          });
      });
    },

    // param是自带参数。 this.$refs.upload.submit() 会自动调用 httpRequest方法.在里面取得file
    httpRequest(params) {
      var formData = new FormData();
      formData.append("file", params.file);
      // formData.append("id", this.item.ID);
      this.$axios
        .post(`ipc/product/stock-upload`, formData)
        .then((response) => {
          this.item.Attachments =
            this.item.Attachments === null ? [] : this.item.Attachments;
          this.item.Attachments.push(response.data);

          this.fileList.push({
            uid: params.file.uid,
            name: response.data.Name,
            url: response.data.Url,
          });
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    handleRemove(file) {
      this.fileList.forEach((obj) => {
        if (obj.uid === file.uid) {
          this.removeList.push(obj.url);
          this.fileList.splice(
            this.fileList.findIndex((item) => item.uid === obj.uid),
            1
          );
        }
      });
    },
    handlePreview(file) {
      const a = document.createElement("a");
      a.setAttribute("download", file.name);
      a.setAttribute("href", file.url);
      a.click();
    },
    handleError(err) {
      this.$message.error(err.message.substring(1, err.message.length - 2));
    },

    //点击上传文件按钮
    onCreateClick() {
      this.fileItem.fileName = "";
      this.uploadVisabled = true;
    },
    onSubmit() {
      this.$refs.fileItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$refs.uploadFile.submit();
      });
    },
    httpFileRequest(params) {
      var formData = new FormData();
      formData.append("file", params.file);
      formData.append("fileName", this.fileItem.fileName);
      // formData.append("id", this.item.ID);
      this.$axios
        .post(`ipc/product/stock-upload`, formData)
        .then((response) => {
          this.item.Attachments =
            this.item.Attachments === null ? [] : this.item.Attachments;
          this.item.Attachments.push(response.data);

          this.fileList.push({
            uid: params.file.uid,
            name: response.data.Name,
            url: response.data.Url,
          });
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
          this.uploadVisabled = false;
        })
        .finally(() => {
          this.onFileClose();
        });
    },
    handleSuccess(response) {
      // this.fileItem.ID = response.ID;
      this.$axios
        .post("ipc/product/stock-upload", this.fileItem)
        .then(() => {
          this.$message({
            message: "上传成功!",
            type: "success",
          });

          this.item.Attachments =
            this.item.Attachments === null ? [] : this.item.Attachments;
          this.item.Attachments.push(response.data);

          this.fileList.push({
            uid: params.file.uid,
            name: response.data.Name,
            url: response.data.Url,
          });
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.onFileClose();
        });
    },
    onFileClose() {
      this.fileItem.fileName = "";
      this.$refs.fileItemForm.resetFields();
      this.$refs.uploadFile.clearFiles();
      this.submitting = false;
      this.uploadVisabled = false;
    },
    judgeFileName() {
      this.fileItem.fileName = this.$refs.uploadFile.uploadFiles[0].name;
    },

    keyup(ev, row, col) {
      this.keyupTo(ev, row, col, this.item.IpcAccessories.length, 2);
    },
    keyupTo(ev, row, col, rowCount, colCount) {
      // 替代 switch 的优雅写法
      const actions = {
        ArrowUp: () => {
          row--;
          if (row < 0) row = rowCount - 1;
        },
        ArrowDown: () => {
          row++;
          if (row >= rowCount) row = 0;
        },
        ArrowLeft: () => {
          col--;
          if (col < 1) col = colCount;
        },
        ArrowRight: () => {
          col++;
          if (col > colCount) col = 1;
        },
        Enter: () => {
          col++;
          if (col > colCount) {
            // 右下角的话保持不动
            if (row === rowCount - 1) {
              col = colCount;
              this.item.IpcAccessories.push({});
            } else {
              col = 1;
              row++;
            }
          }
        },
      };
      let action = actions[ev.key];
      if (action !== undefined) {
        action.call();
        // 用 nextTick 避免 input 还没渲染出来
        this.$nextTick(() => {
          this.$refs["row" + row].focus();
        });
      }
    },
  },
};
</script>

<style scoped>
.dialogDiv {
  height: 650px;
  overflow: auto;
  padding-left: 10px;
  padding-right: 10px;
}
.el-divider--horizontal {
  margin: 12px 0 12px 0;
}
.el-timeline {
  margin: 0;
  font-size: 10px;
  list-style: none;
}
.el-card__body {
  padding: 5px;
}
.el-timeline-item__timestamp {
  color: #909399;
  line-height: 1;
  font-size: 8px;
}
.border-style {
  height: 28px;
  line-height: 28px;
  border-radius: 0 15px 15px 0;
  border-left: 3px solid #409eff;
  padding-left: 5px;
  margin-bottom: 10px;
  background-color: #ecf5ff;
  color: #409eff;
  font-size: 13px;
  font-weight: bolder;
}
</style>
